import { useNavigate, useParams } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import {
  TCreateFormPayload,
  useGetForm,
  usePatchForm,
  useServiceTypes,
} from "../../hooks/forms.hooks";
import FormConfigForm from "./Form";

export function EditFormConfig() {
  const { id = "" } = useParams();
  const {
    data: data1,
    isError: isError1,
    isFetching: isFetching1,
  } = useGetForm(+id, "edit");
  const { isFetching: isFetching2, isError: isError2 } = useServiceTypes();

  const { mutate } = usePatchForm();
  const navigate = useNavigate();

  const onSubmit = (payload: TCreateFormPayload) => {
    mutate(
      { id: +id, ...payload },
      { onSuccess: () => navigate("/form-configurations", { replace: true }) }
    );
  };

  const isLoading = isFetching1 || isFetching2;
  const isError = isError1 || isError2 || (!isLoading && !data1?.id);

  let toRender = null;
  if (isLoading || isError) {
    toRender = (
      <div className="flex justify-center items-center p-8">
        {String(isError1)}
        {String(isError2)}

        {isError ? (
          <p>Something went wrong while fetching info!</p>
        ) : (
          <SpinnerCircular />
        )}
      </div>
    );
  } else {
    toRender = (
      <FormConfigForm
        ctx="edit"
        onSubmit={onSubmit}
        defaultEnabledFields={(data1?.fieldsEnabled || []).map((e) => e.id)}
        defaultEnabledDocuments={(data1?.documentsEnabled || []).map(
          (e) => e.document_config_id
        )}
        defaultValues={{
          active: data1?.active || false,
          name: data1?.name || "",
          serviceName: data1?.serviceName || "",
          type: data1?.type || "",
          isNewForm: false,
        }}
      />
    );
  }

  return <div>{toRender}</div>;
}
